
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/career-design-center",
      function () {
        return require("private-next-pages/cases/career-design-center/index.tsx");
      }
    ]);
  